import CanonicalLink from './CanonicalLink';
export default CanonicalLink;
